import { GetMediaFileNameParams } from '../interfaces/productDetailZoom.interfaces';

const FILE_EXTENSION_PATTERN = /\.([a-z0-9]+)$/i;
const INVALID_FILE_NAME_CHARACTERS = /[\\/:*?"<>|]/g;
const DEFAULT_FILE_EXTENSION = 'webp';

export const getMediaFileName = ({ url, title }: GetMediaFileNameParams) => {
  const [pathname] = url.split('?');
  const originalFileName = pathname.split('/').pop() ?? '';
  const extension = originalFileName.match(FILE_EXTENSION_PATTERN)?.[1] ?? DEFAULT_FILE_EXTENSION;
  const name = title?.trim() || originalFileName.replace(FILE_EXTENSION_PATTERN, '');

  return `${name.replace(INVALID_FILE_NAME_CHARACTERS, '-')}.${extension.toLowerCase()}`;
};
